
import { useState } from "react";
import { IndividualPageSEO } from "@/components/seo/IndividualPageSEO";
import { IndividualPageContent } from "@/components/individual/IndividualPageContent";

const Individual = () => {
  const [showWaitlist, setShowWaitlist] = useState(false);
  const title = "Réservez Restaurants, Hébergements & Événements Locaux dans l'Aisne | NLocale";
  const description = "Découvrez les meilleurs restaurants, hébergements et événements de l'Aisne avec NLocale. Que vous soyez touriste ou résident, profitez d'une expérience unique grâce à notre plateforme locale.";
  const canonicalUrl = "https://onarrivebientot.nlocale.fr/particulier";

  const handleUserTypeChange = (isPro: boolean) => {
    // Handle user type change if needed
  };

  return (
    <>
      <IndividualPageSEO
        title={title}
        description={description}
        canonicalUrl={canonicalUrl}
      />
      
      <main className="bg-gradient-to-b from-white to-gray-50 min-h-screen flex flex-col">
        <IndividualPageContent
          showWaitlist={showWaitlist}
          setShowWaitlist={setShowWaitlist}
          onUserTypeChange={handleUserTypeChange}
        />
      </main>
    </>
  );
};

export default Individual;
